// React-imports
import { ReactElement } from "react";

// Style Imports
import "./expire-link.scss";

const ExpireLink: React.FC = (): ReactElement => {
  return (
    <div className="flex flex-col expire-link-container items-center min-h-screen">
      <div className="background"></div>
      <img src="/images/kamco-logo.png" alt="kamco invest" />
      <div className="white-container">
        <table>
          <tr>
            <td>
              <img src="/images/warning.svg" alt="kamco registeration-image" />
            </td>
          </tr>
          <tr>
            <td>
              <span>Expired link!</span>
            </td>
          </tr>
        </table>
        <span className="border"></span>
        <p className="first-p mt-7">
          Sorry, it seems that the link has <b>expired</b>, you can kindly
          request to resend a new one.
        </p>
      </div>
      <footer className=" flex flex-col mt-auto">
        <ul>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/company/kamco-invest/"
            >
              <img src="/images/linkedin.svg" alt="kamco invest linkedin" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/kamcoinvest"
            >
              <img src="/images/facebook.svg" alt="kamco invest facebook" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://twitter.com/KamcoInvest"
            >
              <img src="/images/twitter.svg" alt="kamco twitter x" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/kamco_invest/?hl=en"
            >
              <img src="/images/instagram.svg" alt="kamco instagram" />
            </a>
          </li>
        </ul>
        <p className=" text-sm md:text-base">Copyright © {new Date().getFullYear()} Kamco Invest. All Rights Reserved</p>
      </footer>
    </div>
  );
};

export default ExpireLink;
